module.exports = __webpack_public_path__ + "shichui.f886dc95.png";